import React from "react";
import * as ReactDOM from "react-dom/client";
import { NikeDesignSystemProvider } from "@nike/nike-design-system-components";
import { ApolloProvider } from "@apollo/client";
import { AuthProvider } from "./auth";
import { client } from "./graphQLClient";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "@nike/eds/dist/index.css";
import "@nike/nike-design-system-components/polyfills";

//  @ts-ignore
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ApolloProvider client={client}>
        <NikeDesignSystemProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </NikeDesignSystemProvider>
      </ApolloProvider>
    </AuthProvider>
  </React.StrictMode>
);
